import {
  GalleryBreakpoint as IGalleryBreakpoint,
  GalleryConfig as IGalleryConfig
} from 'services/api-service'

type SortOrderType = 'MOST_VOTES' | 'MOST_RECENT' | 'LONGEST'
type ArrowLocationType = 'top' | 'overlay' | 'bottom'
type ArrowStyleType = 'button' | 'icon'


export class GalleryConfig implements IGalleryConfig {
  constructor(config: IGalleryConfig) {
    this.breakpoints = config.breakpoints
    this.columnSpacing = config.columnSpacing
    this.headingLevel = config.headingLevel || 2
    this.minContentCount = config.minContentCount
    this.maxContentToReturn = config.maxContentToReturn
    this.minTextContentCharacterCount = config.minTextContentCharacterCount
    this.minTextContentWordCount = config.minTextContentWordCount
    this.includeProductSiblings = config.includeProductSiblings
    this.includeSyndicated = config.includeSyndicated
    this.truncateLength = config.truncateLength
    this.showProgressBar = config.showProgressBar
    this.arrowLocation = config.arrowLocation
    this.arrowStyle = config.arrowStyle
    this.sortOrder = config.sortOrder
    this.widgetDivId = config.widgetDivId
  }

  breakpoints: Array<IGalleryBreakpoint>
  columnSpacing: number
  headingLevel: number
  minContentCount: number
  // don't see this in docs as configurable and don't see it used
  maxContentToReturn: number
  minTextContentCharacterCount: number
  minTextContentWordCount: number
  includeProductSiblings: boolean
  includeSyndicated: boolean
  truncateLength: number
  showProgressBar: boolean
  arrowLocation: ArrowLocationType
  arrowStyle: ArrowStyleType
  sortOrder: SortOrderType
  widgetDivId: string
}

let defaultConfig: IGalleryConfig = {}
export function loadConfig(config: IGalleryConfig): void {
  defaultConfig = new GalleryConfig(config)
}

export { defaultConfig as default }
